export default __webpack_public_path__ + "static/beerbal-4efbc832a23c209ea93ecd9bf0a7aff8.png";